import ROUTE_NAMES from "@/app/exercise/router/router-const";
export default [
  {
    path: "users",
    name: ROUTE_NAMES.USERS,
    component: () => import("@/app/exercise/modules/users/UsersPage.vue"),
  },
  {
    path: "user/:id",
    name: ROUTE_NAMES.USER_DETAILS,
    component: () =>
      import("@/app/exercise/modules/users/UserDetailsPage.vue"),
    redirect: { name: ROUTE_NAMES.USER_DETAILS_EXAMS },
    children: [
      {
        path: "training-exams",
        name: ROUTE_NAMES.USER_DETAILS_EXAMS,
        component: () =>
          import("@/app/exercise/modules/users/components/TrainingExamsTab.vue")
      },
      {
        path: "cbr-exams",
        name: ROUTE_NAMES.USER_DETAILS_EXAMS_CBR,
        component: () =>
          import("@/app/exercise/modules/users/components/CbrExamsTab.vue")
      },
    ]
  },
];
